import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  author: string;
}

const blogPosts: BlogPost[] = [
  {
    id: 'dolunay-etkileri',
    title: 'Dolunay Dönemlerinde Enerji Yönetimi',
    excerpt: 'Dolunay, duygusal yoğunluğun arttığı, içsel farkındalığın derinleştiği güçlü bir zamandır. Bu dönemde enerji alanınızı nasıl koruyabilir ve dengeleyebilirsiniz?',
    category: 'Astroloji',
    date: '15 Ocak 2025',
    readTime: '8 dk',
    image: 'https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/aedf53178de89724821e4a867150a58e.png',
    author: 'Deniz Erin'
  },
  {
    id: 'iliskide-sinastri',
    title: 'İlişkilerde Sinastri: Ruhsal Bağların Haritası',
    excerpt: 'İki kişinin doğum haritalarının karşılaştırılması olan sinastri, ilişkilerdeki dinamikleri, zorlukları ve potansiyelleri ortaya koyar.',
    category: 'İlişkiler',
    date: '12 Ocak 2025',
    readTime: '10 dk',
    image: 'https://public.readdy.ai/ai/img_res/e8b2a9177f3f3c6c1364a49a756fc6c3.jpg',
    author: 'Deniz Erin'
  },
  {
    id: 'cakra-dengeleme',
    title: 'Çakra Dengeleme: 7 Enerji Merkezinizi Uyumlu Hale Getirin',
    excerpt: 'Çakralar, bedenimizin enerji merkezleridir. Dengeli çakralar, fiziksel, duygusal ve spiritüel sağlığımızın temelidir.',
    category: 'Enerji/Şifa',
    date: '8 Ocak 2025',
    readTime: '12 dk',
    image: 'https://readdy.ai/api/search-image?query=seven%20chakras%20alignment%20with%20glowing%20energy%20centers%20meditation%20pose%20colorful%20chakra%20symbols%20spiritual%20healing%20light%20peaceful%20energy%20flow%20navy%20background%20with%20golden%20accents%20holistic%20wellness&width=800&height=500&seq=blog3&orientation=landscape',
    author: 'Deniz Erin'
  },
  {
    id: 'kariyer-astroloji',
    title: 'Astrolojik Haritanızda Kariyer İpuçları',
    excerpt: 'Doğum haritanızdaki 10. ev, MC noktası ve gezegen yerleşimleri, kariyer yolunuz hakkında değerli bilgiler sunar.',
    category: 'Kariyer',
    date: '5 Ocak 2025',
    readTime: '9 dk',
    image: 'https://readdy.ai/api/search-image?query=professional%20success%20path%20with%20astrological%20career%20symbols%20midheaven%20point%20cosmic%20guidance%20for%20work%20life%20golden%20pathway%20through%20stars%20navy%20blue%20sky%20achievement%20and%20purpose%20spiritual%20career&width=800&height=500&seq=blog4&orientation=landscape',
    author: 'Deniz Erin'
  },
  {
    id: 'meditasyon-baslangic',
    title: 'Meditasyona Başlangıç: İlk Adımlar',
    excerpt: 'Meditasyon, zihinsel berraklık ve içsel huzur için güçlü bir araçtır. Başlangıç seviyesinde pratik yapabileceğiniz teknikler.',
    category: 'Spiritüel Yaşam',
    date: '2 Ocak 2025',
    readTime: '7 dk',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20meditation%20beginning%20with%20person%20in%20lotus%20position%20serene%20spiritual%20space%20soft%20golden%20light%20rays%20tranquil%20atmosphere%20navy%20blue%20tones%20mindfulness%20practice%20inner%20peace%20journey&width=800&height=500&seq=blog5&orientation=landscape',
    author: 'Deniz Erin'
  },
  {
    id: 'retro-merkur',
    title: 'Retro Merkür Dönemleri: Kaos mu, Fırsat mı?',
    excerpt: 'Merkür retrosu, iletişim ve teknoloji alanında zorluklar yaşansa da, aslında yeniden değerlendirme ve düzeltme için mükemmel bir zamandır.',
    category: 'Astroloji',
    date: '28 Aralık 2024',
    readTime: '8 dk',
    image: 'https://readdy.ai/api/search-image?query=mercury%20retrograde%20cosmic%20phenomenon%20with%20planet%20mercury%20moving%20backward%20celestial%20mechanics%20communication%20symbols%20navy%20blue%20space%20with%20golden%20planetary%20orbits%20astrological%20timing&width=800&height=500&seq=blog6&orientation=landscape',
    author: 'Deniz Erin'
  },
  {
    id: 'kristal-sifa',
    title: 'Kristallerle Şifa: Hangi Kristal Size Uygun?',
    excerpt: 'Her kristalin kendine özgü bir frekansı ve şifa özelliği vardır. İhtiyacınıza göre doğru kristali seçmek, enerji çalışmalarınızı güçlendirir.',
    category: 'Enerji/Şifa',
    date: '25 Aralık 2024',
    readTime: '11 dk',
    image: 'https://readdy.ai/api/search-image?query=healing%20crystals%20collection%20with%20various%20gemstones%20glowing%20with%20energy%20amethyst%20rose%20quartz%20citrine%20arranged%20beautifully%20golden%20light%20emanating%20navy%20background%20spiritual%20healing%20tools&width=800&height=500&seq=blog7&orientation=landscape',
    author: 'Deniz Erin'
  },
  {
    id: 'yeni-ay-niyetler',
    title: 'Yeni Ay Ritüelleri: Niyetlerinizi Manifestasyon',
    excerpt: 'Yeni ay, yeni başlangıçlar ve niyetler için en güçlü zamandır. Basit ritüellerle bu enerjiyi nasıl kullanabilirsiniz?',
    category: 'Spiritüel Yaşam',
    date: '22 Aralık 2024',
    readTime: '9 dk',
    image: 'https://readdy.ai/api/search-image?query=new%20moon%20ritual%20ceremony%20with%20candles%20crystals%20and%20intention%20setting%20tools%20mystical%20altar%20setup%20dark%20navy%20night%20sky%20golden%20candlelight%20spiritual%20manifestation%20practice&width=800&height=500&seq=blog8&orientation=landscape',
    author: 'Deniz Erin'
  },
  {
    id: 'dogum-haritasi-okuma',
    title: 'Doğum Haritanızı Okumaya Nereden Başlamalısınız?',
    excerpt: 'Doğum haritası, ruhunuzun kozmik parmak izidir. Bu karmaşık haritayı anlamak için temel adımlar ve ipuçları.',
    category: 'Astroloji',
    date: '18 Aralık 2024',
    readTime: '10 dk',
    image: 'https://readdy.ai/api/search-image?query=natal%20birth%20chart%20reading%20with%20detailed%20astrological%20wheel%20zodiac%20signs%20and%20planetary%20positions%20cosmic%20blueprint%20navy%20blue%20background%20golden%20chart%20lines%20spiritual%20self%20discovery&width=800&height=500&seq=blog9&orientation=landscape',
    author: 'Deniz Erin'
  }
];

const categories = ['Tümü', 'Astroloji', 'İlişkiler', 'Kariyer', 'Enerji/Şifa', 'Spiritüel Yaşam'];

const BlogPage = () => {
  const blogPosts = [
    {
      id: '1',
      category: 'Astroloji',
      title: 'Doğum Haritanız Size Ne Anlatıyor?',
      excerpt: 'Doğum haritanız, kişiliğinizin derinliklerini ve yaşam yolculuğunuzun haritasını ortaya koyar.',
      date: '15 Aralık 2024',
      readTime: '5 dk',
      image: 'https://readdy.ai/api/search-image?query=elegant%20birth%20chart%20astrology%20wheel%20with%20zodiac%20symbols%20and%20planetary%20positions%20on%20deep%20navy%20blue%20background%20with%20golden%20accents%20mystical%20professional%20design%20for%20spiritual%20blog%20post&width=800&height=450&seq=blog001&orientation=landscape',
    },
    {
      id: '2',
      category: 'Spiritüel Yaşam',
      title: 'İçsel Huzuru Bulmanın 7 Yolu',
      excerpt: 'Günlük hayatın koşuşturmasında içsel dengenizi korumak için pratik spiritüel uygulamalar.',
      date: '10 Aralık 2024',
      readTime: '7 dk',
      image: 'https://readdy.ai/api/search-image?query=serene%20meditation%20scene%20with%20person%20sitting%20in%20peaceful%20lotus%20position%20surrounded%20by%20soft%20golden%20light%20and%20ethereal%20energy%20waves%20on%20calm%20navy%20blue%20background%20spiritual%20wellness%20blog%20image&width=800&height=450&seq=blog002&orientation=landscape',
    },
    {
      id: '3',
      category: 'Enerji & Şifa',
      title: 'Enerji Dengeleme Nedir ve Nasıl Yapılır?',
      excerpt: 'Bedeninizin ve ruhunuzun enerji akışını dengeleyerek sağlıklı bir yaşam sürdürün.',
      date: '5 Aralık 2024',
      readTime: '6 dk',
      image: 'https://readdy.ai/api/search-image?query=healing%20energy%20flow%20visualization%20with%20glowing%20golden%20light%20streams%20and%20chakra%20points%20on%20human%20silhouette%20against%20deep%20navy%20background%20spiritual%20energy%20healing%20concept%20for%20wellness%20blog&width=800&height=450&seq=blog003&orientation=landscape',
    },
    {
      id: '4',
      category: 'Astroloji',
      title: 'Retro Merkür Döneminde Neler Yapmalı?',
      excerpt: 'Merkür retrosu sırasında dikkat etmeniz gereken noktalar ve bu dönemi en iyi şekilde değerlendirme yolları.',
      date: '1 Aralık 2024',
      readTime: '5 dk',
      image: 'https://readdy.ai/api/search-image?query=mercury%20retrograde%20planet%20moving%20backwards%20in%20cosmic%20space%20with%20mystical%20purple%20and%20navy%20blue%20nebula%20background%20astrological%20concept%20with%20golden%20planetary%20orbit%20lines%20spiritual%20astrology%20blog%20image&width=800&height=450&seq=blog004&orientation=landscape',
    },
    {
      id: '5',
      category: 'Spiritüel Yaşam',
      title: 'Meditasyon Pratiğine Nasıl Başlanır?',
      excerpt: 'Yeni başlayanlar için adım adım meditasyon rehberi ve pratik öneriler.',
      date: '28 Kasım 2024',
      readTime: '6 dk',
      image: 'https://readdy.ai/api/search-image?query=peaceful%20meditation%20beginner%20sitting%20in%20simple%20lotus%20pose%20with%20soft%20morning%20light%20and%20minimalist%20zen%20garden%20background%20calm%20navy%20blue%20tones%20with%20golden%20sunrise%20glow%20spiritual%20wellness%20meditation%20guide%20blog%20image&width=800&height=450&seq=blog005&orientation=landscape',
    },
    {
      id: '6',
      category: 'Enerji & Şifa',
      title: 'Kristallerin Şifa Gücü',
      excerpt: 'Farklı kristallerin özellikleri ve enerji dengeleme için nasıl kullanılacağı.',
      date: '25 Kasım 2024',
      readTime: '7 dk',
      image: 'https://readdy.ai/api/search-image?query=collection%20of%20healing%20crystals%20including%20amethyst%20rose%20quartz%20and%20clear%20quartz%20arranged%20beautifully%20on%20deep%20navy%20blue%20silk%20fabric%20with%20golden%20light%20rays%20spiritual%20crystal%20healing%20energy%20therapy%20blog%20image&width=800&height=450&seq=blog006&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative py-32 overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-dark via-[#1a2332] to-primary-dark"></div>
        
        {/* Decorative Elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gold rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-gold rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-6">
              Blog
            </h1>
            <p className="text-cream text-lg md:text-xl max-w-2xl mx-auto">
              Astroloji, spiritüel yaşam ve enerji şifası üzerine yazılar
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Featured Post */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-16"
          >
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 bg-gradient-to-br from-cream to-white rounded-3xl shadow-xl overflow-hidden">
              <div className="relative h-96 lg:h-auto">
                <img
                  src={blogPosts[0].image}
                  alt={blogPosts[0].title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-6 left-6">
                  <span className="px-4 py-2 bg-gold text-primary-dark text-xs font-bold rounded-full">
                    ÖNE ÇIKAN
                  </span>
                </div>
              </div>
              <div className="p-8 flex flex-col justify-center">
                <div className="flex items-center space-x-4 mb-4 text-sm">
                  <span className="text-sm text-gold font-medium">{blogPosts[0].category}</span>
                  <span className="text-sm text-text-secondary">{blogPosts[0].date}</span>
                  <span className="text-sm text-text-secondary">{blogPosts[0].readTime} okuma</span>
                </div>
                <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary-dark mb-4">
                  {blogPosts[0].title}
                </h2>
                <p className="text-text-secondary leading-relaxed mb-6">
                  {blogPosts[0].excerpt}
                </p>
                <Link
                  to={`/blog/${blogPosts[0].id}`}
                  className="inline-flex items-center text-gold font-medium hover:gap-3 transition-all duration-300 cursor-pointer"
                >
                  Devamını Oku
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </motion.div>

          {/* Blog Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.slice(1).map((post, index) => (
              <motion.article
                key={post.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group"
              >
                <Link to={`/blog/${post.id}`} className="block cursor-pointer">
                  {/* Image */}
                  <div className="relative overflow-hidden rounded-t-2xl mb-6">
                    <div className="w-full h-64">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                      />
                    </div>
                    
                    {/* Category Badge */}
                    <div className="absolute top-4 left-4">
                      <span className="px-4 py-2 bg-gold text-primary-dark text-xs font-bold rounded-full">
                        {post.category}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div>
                    {/* Meta */}
                    <div className="flex items-center space-x-3 text-xs uppercase tracking-wider text-text-light mb-3">
                      <span>{post.date}</span>
                      <span>•</span>
                      <span>{post.readTime} Okuma</span>
                    </div>

                    {/* Title */}
                    <h3 className="font-serif text-2xl font-bold text-primary-dark mb-3 leading-tight group-hover:text-gold transition-colors duration-300">
                      {post.title}
                    </h3>

                    {/* Excerpt */}
                    <p className="text-text-medium leading-relaxed mb-4 line-clamp-2">
                      {post.excerpt}
                    </p>

                    {/* Read More Link */}
                    <div className="flex items-center text-gold text-sm font-medium group-hover:translate-x-1 transition-transform duration-300">
                      <span>Devamını Oku</span>
                      <i className="ri-arrow-right-line ml-2"></i>
                    </div>
                  </div>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;